import { useState, useMemo, useEffect } from 'react';

import mileage17 from './data/2025-04-17-mileage.json'
import speed17 from './data/2025-04-17-speed.json';
import mileage18 from './data/mileage.json';
import speed18 from './data/speed.json';
import mileage19 from './data/2025-04-19-mileage.json'
import speed19 from './data/2025-04-19-speed.json';

import TachographChart from './components/TachographChart';
import DigitalTachographChart from './components/DigitalTachographChart';
import LeftArrowButton from './components/Icons/LeftIcon';
import RightArrowButton from './components/Icons/RightIcon';
import './App.css';

import { DriverData } from './types/common';

type ChartType = 'traditional' | 'digital';

const activeDriverData = {
  '2025-04-17': [
    {
      name: '袁宗華',
      cardId: '179-KN',
      driveHours: {
        start: '2025-04-17 00:00:00',
        end: '2025-04-17 13:35:34',
      },
      color: '#FF3366',
      borderColor: '#CC2952'
    }
  ],
  '2025-04-18': [
    {
      name: '袁宗華',
      cardId: '179-KN',
      driveHours: {
        start: '2025-04-18 00:00:00',
        end: '2025-04-18 13:35:34',
      },
      color: '#FF3366',
      borderColor: '#CC2952'
    },
    {
      name: '袁宗華A',
      cardId: '179-KN',
      driveHours: {
        start: '2025-04-18 14:40:00',
        end: '2025-04-18 17:35:34',
      },
      color: '#00ff00',
      borderColor: '#00CC00'
    }
  ],
  '2025-04-19': [
    {
      name: '袁宗華',
      cardId: '179-KN',
      driveHours: {
        start: '2025-04-18 00:00:00',
        end: '2025-04-18 13:35:34',
      },
      color: '#FF3366',
      borderColor: '#CC2952'
    },
    {
      name: '袁宗華A',
      cardId: '179-KN',
      driveHours: {
        start: '2025-04-18 14:40:00',
        end: '2025-04-18 17:35:34',
      },
      color: '#00ff00',
      borderColor: '#00CC00'
    }
  ],
}

const mileageMap = {
  '2025-04-17': mileage17,
  '2025-04-18': mileage18,
  '2025-04-19': mileage19
}

const speedMap = {
  '2025-04-17': speed17,
  '2025-04-18': speed18,
  '2025-04-19': speed19
}

const TodayDate = '2025-04-19'

function App() {
  const [chartType, setChartType] = useState<ChartType>('digital');
  const [date, setDate] = useState<string>('2025-04-18');
  const [driverData, setDriverData] = useState<DriverData[]>([]);
  const [mileage, setMileage] = useState({})
  const [speed, setSpeed] = useState({})

  useEffect(() => {
    setDriverData(activeDriverData[date as keyof typeof activeDriverData]);
    setMileage(mileageMap[date as keyof typeof mileageMap]);
    setSpeed(speedMap[date as keyof typeof speedMap]);
  }, [date])

  const isToday = useMemo(() => {
    return date === TodayDate
  }, [date])

  const traditionalClass = useMemo(() => {
    return [
      'chart-type-switch-item--traditional',
      chartType === 'traditional' ? 'active' : ''
    ].join(' ')
  }, [chartType])

  const digitalClass = useMemo(() => {
    return [
      'chart-type-switch-item--digital',
      chartType === 'digital' ? 'active' : ''
    ].join(' ')
  }, [chartType])

  const activeDate = useMemo(() => {
    return date.split('-').join('/');
  }, [date])

  const handleChangePreviousDate = () => {
    const currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate() - 1);
    setDate(currentDate.toISOString().split('T')[0]);
  }

  const handleChangeNextDate = () => {
    const currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate() + 1);
    setDate(currentDate.toISOString().split('T')[0]);
  }

  return (
    <div className="App">
      <div className="chart-type-switch-container">
        { date !== '2025-04-17' ? (
          <LeftArrowButton 
            label={`4月${new Date(date).getDate() - 1}`} 
            className="chart-type-switch-item--left" 
            onClick={handleChangePreviousDate} 
          />
        ) : <div />}
        <div className="chart-type-switch">
          <div
            onClick={() => setChartType('traditional')}
            className={traditionalClass}
          >
            傳統
          </div>
          <div
            onClick={() => setChartType('digital')}
            className={digitalClass}
          >
            數位
          </div>
        </div>
        { date !== '2025-04-19' ? (
          <RightArrowButton 
            label={`4月${new Date(date).getDate() + 1}`}
            className="chart-type-switch-item--right" 
            onClick={handleChangeNextDate} 
          />
        ) : <div />}
      </div>
      <ul className="tachograph-info">
        {/* TODO should be removed after the driver data is ready */}
        <li>
          <p>站所：台北站</p>
        </li>
        <li>
          <p>車牌：179-KN</p>
        </li>
        <li>
          <p>查詢時間：{activeDate}</p>
        </li>
        <li>
          <p>駕駛：{driverData.map(driver => driver.name).join(', ')}</p>
        </li>
        <li>
          <p>車機：JASSLIN/數位式行車記錄器</p>
        </li>
      </ul>
      {chartType === 'traditional' && <TachographChart mileage={mileage} speed={speed} driverData={driverData} isToday={isToday} />}
      {chartType === 'digital' && <DigitalTachographChart mileage={mileage} speed={speed} driverData={driverData} isToday={isToday} />}
    </div>
  );
}

export default App;
